export enum TabIds {
	media = "media",
	about = "about",
	"sparkys-reports" = "sparkys-reports",
	checklists = "checklists",
	sheets = "sheets",
	documents = "documents",
	comments = "comments"
}
